import React from 'react'
import { connect } from 'react-redux'
import {
  Route,
  NavLink,
  MemoryRouter
} from "react-router-dom";
// import CurrencyMaster from "./CurrencyMaster";
import ExchangeMaster from "./ExchangeMaster"; 


class CurrencyContainer extends React.Component {
  
  render() {
    return (
      <MemoryRouter>
      <div className="popup-content">
        <div className="medium-12 title">{this.props.content.title}</div>
        <ul className="headers heading">
            {/* <li><NavLink exact to="/">{this.props.content.currency}</NavLink></li>             */}
            <li><NavLink to="/">{this.props.content.exchange}</NavLink></li>            
        </ul>
        <div className="content">
            {/* <Route exact path="/" component={CurrencyMaster}/> */}
            <Route path="/" component={ExchangeMaster}/>          
        </div>         
      </div>
      </MemoryRouter>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    language: state.language,
    content: state.content.currencyManager
  }
}

export default connect(mapStateToProps)(CurrencyContainer)
